export const replaceAuthTokens = (input: string): string =>
  input.replace(/(accessToken|refreshToken|idToken)=(.*?)(&|$)/g, '$1=MASKED$3')
